/* eslint-disable camelcase */
module.exports = {
	methods: {
		comments() {
			const self = this;

			return {
				async list(dealId, offset = 0, limit = self.limit) {
					try {
						const response = await self.$http.get(`deals/${dealId}/comments`, {
							params: {
								offset,
								limit,
							},
							headers: {
								Authorization: false,
							},
						});

						const deals = {
							total: response.data.comments.total,
							results: response.data.comments.results,
						};

						return {
							ok: true,
							data: deals,
							error: null,
						};
					} catch (error) {
						return {
							ok: false,
							data: [],
							error: null,
						};
					}
				},
				async get(dealId, commentId) {
					try {
						const response = await self.$http.get(`deals/${dealId}/comments/${commentId}`, null, {
							headers: { Authorization: true },
						});

						return {
							ok: true,
							data: response.data.comment,
							error: null,
						};
					} catch (error) {
						return {
							ok: false,
							data: null,
							error: null,
						};
					}
				},
				async add({ dealId, text, parentId = null }) {
					try {
						let url;

						if (parentId) url = `deals/${dealId}/comments/${parentId}`;
						if (!parentId) url = `deals/${dealId}/comments`;

						const response = await self.$http.post(
							url, { text }, {
								headers: {
									Authorization: true,
								},
							},
						);

						self.resetStatus();
						return response.data.comment.id;
					} catch (error) {
						self.resetStatus();

						return false;
					}
				},
				async edit({ dealId, id, text }) {
					try {
						await self.$http.patch(
							`deals/${dealId}/comments/${id}`, {
								text,
							}, {
								headers: {
									Authorization: true,
								},
							},
						);

						self.resetStatus();

						return true;
					} catch (error) {
						self.resetStatus();
						return false;
					}
				},
				async like(dealId, commentId) {
					try {
						await self.$http.put(
							`deals/${dealId}/comments/${commentId}/like`, null, {
								headers: {
									Authorization: true,
								},
							},
						);

						self.resetStatus();

						return true;
					} catch (error) {
						self.resetStatus();
						return false;
					}
				},
				async unlike(dealId, commentId) {
					try {
						await self.$http.delete(
							`deals/${dealId}/comments/${commentId}/like`, {
								headers: {
									Authorization: true,
								},
							},
						);

						self.resetStatus();

						return true;
					} catch (error) {
						self.resetStatus();
						return false;
					}
				},
				async replies({ dealId, replyId, offset = 0, limit = self.limit }) {
					try {
						const response = await self.$http.get(
							`deals/${dealId}/comments/${replyId}/replies`, {
								params: {
									offset,
									limit,
								},
								headers: {
									Authorization: false,
								},
							},
						);

						const deals = {
							total: response.data.comments.total,
							results: response.data.comments.results,
						};

						return {
							ok: true,
							data: deals,
							error: null,
						};
					} catch (error) {
						return {
							ok: false,
							data: [],
							error: null,
						};
					}
				},
				async report(commentId) {
					try {
						await self.$http.put(
							`comments/${commentId}/report`, null, {
								headers: {
									Authorization: true,
								},
							},
						);

						self.resetStatus();

						return true;
					} catch (error) {
						self.resetStatus();
						return false;
					}
				},
				async delete(dealId, commentId) {
					try {
						await self.$http.delete(
							`deals/${dealId}/comments/${commentId}`, {
								headers: {
									Authorization: true,
								},
							},
						);

						self.resetStatus();

						return true;
					} catch (error) {
						self.resetStatus();
						return false;
					}
				},
			};
		},
	},
};
